import axios from "axios";
import Config from "src/config";

// Biblioteca de templates pré-aprovados da Meta (/message_template_library)
const v1_actionMessengerBiblioteca = (clienteId, params = {}) => {
    const query = new URLSearchParams();
    if (params.canalId) query.set('canalId', params.canalId);
    if (params.search) query.set('search', params.search);
    if (params.language) query.set('language', params.language);
    if (params.topic) query.set('topic', params.topic);
    if (params.usecase) query.set('usecase', params.usecase);
    if (params.industry) query.set('industry', params.industry);
    if (params.limit) query.set('limit', params.limit);

    const queryString = query.toString() ? `?${query.toString()}` : '';

    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/biblioteca${queryString}`
    });
};

export default v1_actionMessengerBiblioteca;
